import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, InnerHeading, MainHeading, SpanStyled } from '../../ui/Elements'
import { ArrowBtnBrown, ComMap, MBS, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr, Vision, VisionAr, VisionBg, VisionBgAr } from '../../ui/AllImages'
import { useInView } from 'react-intersection-observer'
import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../ui/CustomElements'
import i18n from '../../Languages/INEXT'
import { VisionMissionList } from '../projectData/Data'
import { Animate } from 'react-simple-animate'
const AboutVision = () => {
    const { t } = useTranslation()
    const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // When visible, set to true
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // run animation once
        }
      },
      {
        threshold: 0.1, // 20% of section visible triggers the animation
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);
    const start = { opacity: 0, transform: 'translateY(-40px)' };
    const end = { opacity: 1, transform: 'translateY(0)' };
    const start2 = { opacity: 0, transform: 'translateY(100px)' };
    const end2 = { opacity: 1, transform: 'translateY(0)' };
    return (

        <Col md={12} className='about-col-wrap about-vision-col-wrap' ref={sectionRef}>
                <Row className='aboutVisionRow'>
                    
                    <Col lg={6} md={12} className='about-col vision-col-ctnt'>
                        {VisionMissionList.map((list, key) => (
                          <Animate
                                                play={isVisible}
                                                duration={1}
                                                delay={1}
                                                start={start}
                                                end={end}
                                            >
                            <Box className='visionMissionContent' key={key}>
                                <Box className='visionMissionImg'>
                                    {list.img}
                                </Box>
                                <Box className='visionMissionContentInner'>
                                    <MainHeading className='main-heading main-heading-vis-mis mb-3' size="40px">
                                        {t(list.title)}
                                    </MainHeading>
                                    <SpanStyled className='vis-mis-txt mb-4'>
                                        {t(list.txt)}
                                    </SpanStyled>
                                </Box>
                            </Box>
                            </Animate>
                        ))}
                    </Col>
                   
                    <Col lg={6} md={12} className='about-col vision-col-img'>
                        {i18n.language === "ar" ? 
                            <>
                                <img src={VisionAr} alt="building" /> <img src={VisionBgAr} className='visionSketch' alt="buildingSketch" />
                            </>
                        : 
                              <>
                                <img src={Vision} alt="building" /> <img src={VisionBg} className='visionSketch' alt="buildingSketch" />
                            </>
                        }
                    </Col>
                </Row>
            </Col>

    )
}


export default AboutVision
